import { FixedBlock } from './FixedBlock'
import { Colors } from '../../config'
import { uniqueId } from '../../helpers'

export class IdleBlock extends FixedBlock {
  constructor (start, time, id = uniqueId(), prev = null, next = null) {
    super({ start, time, id, part: 'idle', color: Colors.fixedIdle, kind: 'idle' }, prev, next)
  }
}

export class OutageBlock extends FixedBlock {
  constructor (start, time, id = uniqueId(), prev = null, next = null) {
    super({ start, time, id, part: 'planned outage', color: Colors.outage, kind: 'planned outage' }, prev, next)
  }
}
